import Vue from 'vue';
import * as moment from 'moment';

Vue.filter('militaryTimeToStandard', (val) => {
  if (!val) return '';
  const timeArray = val.split(':');
  let hoursString = timeArray[0].toString();
  const minutesString = timeArray[1].toString();

  let period;
  if (hoursString === '00') {
    period = 'AM';
    hoursString = 12;
  } else if (hoursString > '12') {
    hoursString -= 12;
    period = 'PM';
  } else if (hoursString === '12') {
    period = 'PM';
  } else {
    period = 'AM';
  }
  return `${hoursString}:${minutesString} ${period}`;
});
Vue.filter('formatDate', (val) => {
  if (!val) return '';
  return moment(val, 'YYYY-MM-DD').format('MM/DD/YYYY');
});
Vue.filter('formatDateWithTime', (val) => {
  return moment(val, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YYYY hh:mm a');
});



// WEBPACK FOOTER //
// ./src/filters/filters.js